module.exports = __webpack_public_path__ + "img/list-numbers.ef5d1b37.svg";